module.exports = __webpack_public_path__ + "img/button_2.89d2f107.png";